<template>

  <IconsLoader v-if="isLoading"
               size="md"/>

  <FrameDivider v-else
                :render-pane="!isMobile"
                :is-pane-shadowed="true">
    <template slot="primary">
      <DocuformView :item="docuform"
                    :matter="matter"
                    :is-mobile="isMobile"
                    :contact="currContact"/>
    </template>

    <template slot="secondary">
      <Matter :uid="docuform.matter_uid"
              :mobileView="false"
              :paneView="true"/>
    </template>

  </FrameDivider>
</template>

<script>
import FrameDivider from "@/modules/frameDivider/FrameDivider";
import DocuformView from "@/modules/docuform/views/DocuformView";
import Matter from "@/modules/matters/views/Matter";
import {IconsLoader} from "@/modules/common/components";
import {mapGetters} from "vuex";

export default {
  name: "DocuformPage",
  components: { FrameDivider, DocuformView, Matter, IconsLoader },
  props: {
    uid: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      isLoading: true
    };
  },
  async created() {
    this.$frontageApi.listen('reload-docuform', this.reloadDocuform);
    await this.$store.dispatch({type: 'mattersModule/loadDocuform', payload: {uid: this.uid}});
    await this.$store.dispatch({type: 'mattersModule/fetchMatterData', payload: {matterUid: this.docuform.matter_uid}});
    this.isLoading = false;
    this.$store.commit('setAngularOrigin', 'docuform')
  },
  computed: {
    ...mapGetters(['isMobile']),
    ...mapGetters('mattersModule', ['matter', 'currContact', 'docuform'])
  },
  methods: {
    reloadDocuform(data) {
      this.uid === data.uid && this.$store.dispatch({type: 'mattersModule/loadDocuform', payload: {uid: this.uid}});
    }
  },
  destroyed() {
    this.$frontageApi.remove('reload-docuform', this.reloadDocuform);
  }
}
</script>

<style lang="scss" scoped>
</style>
